<template>
  <div class="d-center flex-column">
        <div class="account">
            <el-form  :model="ruleForm"  :rules="rules" ref="ruleForm"> 
                <el-form-item label="新登录账号" prop="username" label-width="140px">
                    <el-input  v-model="ruleForm.username" placeholder="请输入新登录账号" @blur="trimUsername"  ></el-input>
                </el-form-item>
            </el-form>
            <p class="hint-text"><i class="el-icon-warning"></i>设置登录账号后，请使用新账号登录</p>
            <el-button type="primary" @click="submitForm" style="width: 660px; margin-left:140px;">确定</el-button>
        </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
export default {
  name: 'Account',
  components: {},
  props: {},
  data() {
    return {
        ruleForm: {
            username: ''
        },
        rules: {
            username: [
                { required: true, message: '请输入新登录账号', trigger: 'blur' },
                { min: 4, max: 20, message: '长度在 4 到 20 个字符', trigger: 'blur' },
                {
                    pattern: /^[\u4e00-\u9fa5a-zA-Z0-9]+$/,
                    message: '账号只能包含汉字、字母、数字，不能包含特殊字符',
                    trigger: 'blur'
                }
            ]
        }
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    ...mapActions(['modifyAccount']),
    // 去除用户名首尾空格
    trimUsername() {
      if (this.ruleForm.username) {
        this.ruleForm.username = this.ruleForm.username.trim();
      }
    },
    //验证账户
    submitForm( ){
        this.$refs['ruleForm'].validate((valid) => {
            if (valid) {
                this.modifyAccount({
                    username: this.ruleForm.username,
                });
            } else {
                return false;
            }
        });
    },
  }
};
</script>

<style lang="scss" scoped>
    .account{
        width: 800px;
    }
    .hint-text{
        color:var(--smtc-color-text-red);
        display: flex;
        align-items: center;
        margin-left: 140px;
        padding: 10px;
        border-radius: 4px;
        margin-bottom: 20px;
        background-color: #fff5f5;
        i{
            margin-right: 4px;
            font-size: 16px;
        }
    }
</style>
